// TODO(boundaries) Fix after modernizing architecture
/* eslint-disable @nx/enforce-module-boundaries */
import { CostCenterArticleRangesPermissions } from '@mp/document-management/cost-center-article-ranges/feature';
import { DeploymentSettingsPermissions } from '@mp/system/deployment-settings/feature';
import { PlatformPackagingUnitsPermissions } from '@mp/system/platform-packaging-units/feature';
import { BIAnalyticsPermissions } from '@mpbi/feature';
import {
  ArticleMatcherPermissions,
  ArticleRangesPermissions,
  ArticleSearchPermissions,
  CategoriesPermissions,
  ClinicCatalogsPermissions,
  IndustryCatalogsPermissions,
  IndustryPriceListsPermissions,
  PlatformCatalogsPermissions,
} from '@mpcm/feature';
import { GroupedRequisitionsPermissions } from '@mpdm/feature';
import {
  ApiKeysPermissions,
  IdentityUsersPermissions,
  OrganizationsPermissions,
  hasAnyEnabledOrganizationSetting,
} from '@mpk/feature';
import { MedicalShopPermissions } from '@mpms/feature';
import { AddressesPermissions, CostCentersPermissions } from '@mpomd/feature';
import { ClinicSuppliersPermissions, PlatformSuppliersPermissions } from '@mpsm/feature';
import { TransactionManagementPermissions } from '@mptm/feature';

import { NavigationStructure } from './navigation-item';

export const navigationStructure: NavigationStructure = [
  {
    label: 'Analytics',
    route: 'analytics',
    icon: 'insert_chart',
    permissions: [BIAnalyticsPermissions.UseBI],
    loadChildRoutes: async () => (await import('@mpbi/routes')).BUSINESS_INTELLIGENCE_ANALYTICS_ROUTES,
  },
  {
    label: 'Artikelsuche',
    route: 'artikel',
    icon: 'search',
    permissions: [ArticleSearchPermissions.UseArticleSearch],
    loadChildRoutes: async () => (await import('@mpcm/routes')).CONTENT_MANAGER_ARTICLE_SEARCH_ROUTES,
  },
  {
    label: 'Belege',
    icon: 'list_alt',
    route: 'orders',
    children: [
      {
        label: 'Anforderungen',
        route: 'document-management',
        icon: 'content_paste',
        // This really has no permission but only makes sense if one can create purchase requisitions.
        permissions: [MedicalShopPermissions.UseMedicalShop],
        loadChildRoutes: async () => (await import('@mpdm/routes')).PURCHASE_REQUISITIONS_ROUTES,
      },
      {
        label: 'Sammelbestellungen',
        route: 'grouped-requisitions',
        icon: 'content_paste_go',
        permissions: [GroupedRequisitionsPermissions.ViewGroupedRequisitions],
        loadChildRoutes: async () => (await import('@mpdm/routes')).GROUPED_REQUISITIONS_ROUTES,
      },
      {
        label: 'Bestellungen',
        route: 'transaction-management',
        icon: 'receipt',
        permissions: [TransactionManagementPermissions.UseTransactionManagement],
        loadChildRoutes: async () => (await import('@mptm/routes')).TRANSACTION_MANAGEMENT_ORDERS_ROUTES,
      },
    ],
  },
  {
    label: 'Content Management',
    icon: 'document_scanner',
    route: 'content-management',
    children: [
      {
        label: 'Matchvorschläge',
        route: 'match-proposals',
        icon: 'link',
        permissions: [ArticleMatcherPermissions.ManageArticleMatches],
        loadChildRoutes: async () => (await import('@mpcm/routes')).CONTENT_MANAGER_MATCH_PROPOSALS_ROUTES,
      },
      {
        label: 'Warengruppen',
        route: 'categories',
        icon: 'category',
        permissions: [CategoriesPermissions.ViewAndExportCategories],
        loadChildRoutes: async () => (await import('@mpcm/routes')).CONTENT_MANAGER_CATEGORIES_ROUTES,
      },
    ],
  },
  {
    label: 'Katalogmanagement',
    icon: 'menu_book',
    route: 'katalog-management',
    children: [
      {
        label: 'Klinikkataloge',
        route: 'klinikkataloge',
        icon: 'menu_book',
        permissions: [ClinicCatalogsPermissions.ManageClinicCatalogs],
        loadChildRoutes: async () => (await import('@mpcm/routes')).CONTENT_MANAGER_CLINIC_CATALOGS_ROUTES,
      },
      {
        label: 'Industriekataloge',
        route: 'kataloge',
        icon: 'menu_book',
        permissions: [IndustryCatalogsPermissions.ViewIndustryCatalogs],
        loadChildRoutes: async () => (await import('@mpcm/routes')).CONTENT_MANAGER_INDUSTRY_CATALOGS_ROUTES,
      },
      {
        label: 'Industrie-Preislisten',
        route: 'industrie-preislisten',
        icon: 'euro',
        permissions: [IndustryPriceListsPermissions.ViewIndustryPriceLists],
        loadChildRoutes: async () => (await import('@mpcm/routes')).CONTENT_MANAGER_INDUSTRY_PRICE_LISTS_ROUTES,
      },
      {
        label: 'Plattformkataloge',
        route: 'plattformkataloge',
        icon: 'menu_book',
        permissions: [PlatformCatalogsPermissions.ViewPlatformCatalogs],
        loadChildRoutes: async () => (await import('@mpcm/routes')).CONTENT_MANAGER_PLATFORM_CATALOGS_ROUTES,
      },
      {
        label: 'Sortimente',
        route: 'article-ranges',
        icon: 'inventory_2',
        permissions: [ArticleRangesPermissions.ManageArticleRanges],
        loadChildRoutes: async () => (await import('@mpcm/routes')).CONTENT_MANAGER_ARTICLE_RANGES_ROUTES,
      },
    ],
  },
  {
    label: 'Lieferantenmanagement',
    icon: 'local_shipping',
    route: 'lieferanten-management',
    children: [
      {
        label: 'Kliniklieferanten',
        route: 'kliniklieferanten',
        icon: 'local_shipping',
        permissions: [ClinicSuppliersPermissions.ViewClinicSuppliers],
        loadChildRoutes: async () => (await import('@mpsm/routes')).SUPPLIER_MANAGEMENT_CLINIC_SUPPLIERS_ROUTES,
      },
      {
        label: 'Plattformlieferanten',
        route: 'lieferanten',
        icon: 'local_shipping',
        permissions: [PlatformSuppliersPermissions.ViewPlatformSuppliers],
        loadChildRoutes: async () => (await import('@mpsm/routes')).SUPPLIER_MANAGEMENT_PLATFORM_SUPPLIERS_ROUTES,
      },
    ],
  },
  {
    label: 'MarketPlace',
    route: 'market-place',
    icon: 'store',
    permissions: [MedicalShopPermissions.UseMedicalShop],
    loadChildRoutes: async () => (await import('@mp/medical-shop-2/core')).MEDICAL_SHOP_ROUTES,
  },
  {
    label: 'Meine Organisation',
    icon: 'home_work',
    route: 'organisation',
    children: [
      {
        label: 'Adressen',
        route: 'adressen',
        icon: 'location_on',
        permissions: [AddressesPermissions.ManageAllAddresses],
        loadChildRoutes: async () => (await import('@mpomd/routes')).ORGANIZATION_MASTER_DATA_ADDRESSES_ROUTES,
      },
      {
        label: 'Kostenstellen',
        route: 'kostenstellen',
        icon: 'account_balance_wallet',
        permissions: [CostCentersPermissions.ManageAllCostcenters],
        loadChildRoutes: async () => (await import('@mpomd/routes')).ORGANIZATION_MASTER_DATA_COST_CENTERS_ROUTES,
      },
      {
        label: 'Fachbereichssortimente',
        route: 'cost-center-article-ranges',
        icon: 'inventory_2',
        permissions: [CostCenterArticleRangesPermissions.ManageCostCenterArticleRanges],
        loadChildRoutes: async () => (await import('@mpdm/routes')).COST_CENTER_ARTICLE_RANGES_ROUTES,
      },
      {
        label: 'API Keys',
        route: 'api-keys',
        icon: 'key',
        permissions: [ApiKeysPermissions.ManageApiKeys],
        loadChildRoutes: async () => (await import('@mpk/routes')).KERNEL_API_KEYS_ROUTES,
      },
      {
        label: 'Benutzer',
        route: 'benutzer',
        icon: 'people',
        permissions: [IdentityUsersPermissions.ManageOrganizationUsers],
        loadChildRoutes: async () => (await import('@mpk/routes')).KERNEL_CURRENT_ORGANIZATION_USERS_ROUTES,
      },
      {
        label: 'Rollen',
        route: 'rollen',
        icon: 'policy',
        permissions: [IdentityUsersPermissions.ManageOrganizationUsers],
        loadChildRoutes: async () => (await import('@mpk/routes')).KERNEL_CURRENT_ORGANIZATION_ROLES_ROUTES,
      },
      {
        label: 'Einstellungen',
        route: 'settings',
        icon: 'settings',
        isEnabled: hasAnyEnabledOrganizationSetting,
        loadChildRoutes: async () => (await import('@mpk/routes')).KERNEL_ORGANIZATION_SETTINGS_ROUTES,
      },
      {
        label: 'Info',
        route: 'info',
        icon: 'info',
        loadChildRoutes: async () => (await import('@mpk/routes')).KERNEL_CURRENT_ORGANIZATION_INFO_ROUTES,
      },
    ],
  },
  {
    label: 'System',
    icon: 'settings',
    route: 'system',
    children: [
      {
        label: 'Benutzer',
        route: 'benutzer',
        icon: 'people',
        permissions: [IdentityUsersPermissions.ManageAllUserAndRoles],
        loadChildRoutes: async () => (await import('@mpk/routes')).KERNEL_USERS_ROUTES,
      },
      {
        label: 'Rollen',
        route: 'rollen',
        icon: 'policy',
        permissions: [IdentityUsersPermissions.ManageAllUserAndRoles],
        loadChildRoutes: async () => (await import('@mpk/routes')).KERNEL_ROLES_ROUTES,
      },
      {
        label: 'Organisationen',
        route: 'organisationen',
        icon: 'account_balance',
        permissions: [OrganizationsPermissions.ManageOrganizations],
        loadChildRoutes: async () => (await import('@mpk/routes')).KERNEL_ORGANIZATIONS_ROUTES,
      },
      {
        label: 'Deployment Einstellungen',
        route: 'deployment-settings',
        icon: 'support',
        permissions: [DeploymentSettingsPermissions.ManageSupportSettings],
        loadChildRoutes: async () => (await import('@mp/system/deployment-settings/routes')).DEPLOYMENT_SETTINGS_ROUTES,
      },
      {
        label: 'Plattformeinheiten',
        route: 'platform-packaging-units',
        icon: 'straighten',
        permissions: [PlatformPackagingUnitsPermissions.ManagePlatformPackagingUnits],
        loadChildRoutes: async () =>
          (await import('@mp/system/platform-packaging-units/feature')).PLATFORM_PACKAGING_UNITS_ROUTES,
      },
      {
        label: 'Info',
        route: 'info',
        icon: 'info',
        loadChildRoutes: async () => (await import('@mp/system/info/feature')).INFO_ROUTES,
      },
    ],
  },
];
